export const CI_PPT_FACTORS = {
  5: [
    "1",
    "1.17753",
    "1.34823",
    "1.51236",
    "1.67018",
    "1.82193",
    "1.96785",
    "2.10815",
    "2.24305",
    "2.37277",
    "2.4975",
    "2.61743",
    "2.73274",
    "2.84363",
    "2.95024",
    "3.05276",
  ],
  6: [
    "0",
    "1",
    "1.14497",
    "1.28436",
    "1.41838",
    "1.54725",
    "1.67117",
    "1.79032",
    "1.90489",
    "2.01505",
    "2.12097",
    "2.22282",
    "2.32075",
    "2.41492",
    "2.50546",
    "2.59252",
  ],
  7: [
    "0",
    "0",
    "1",
    "1.12175",
    "1.2388",
    "1.35136",
    "1.45958",
    "1.56365",
    "1.66371",
    "1.75992",
    "1.85244",
    "1.94139",
    "2.02692",
    "2.10917",
    "2.18825",
    "2.26428",
  ],
  8: [
    "0",
    "0",
    "0",
    "1",
    "1.10436",
    "1.2047",
    "1.30118",
    "1.39395",
    "1.48315",
    "1.56892",
    "1.65139",
    "1.7307",
    "1.80695",
    "1.88026",
    "1.95076",
    "2.01855",
  ],
  9: [
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.09086",
    "1.17823",
    "1.26223",
    "1.343",
    "1.42067",
    "1.49535",
    "1.56716",
    "1.6362",
    "1.70259",
    "1.76643",
    "1.82781",
  ],
  10: [
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.08009",
    "1.1571",
    "1.23114",
    "1.30234",
    "1.3708",
    "1.43663",
    "1.49992",
    "1.56078",
    "1.6193",
    "1.67557",
  ],
  11: [
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.0713",
    "1.13986",
    "1.20578",
    "1.26916",
    "1.3301",
    "1.3887",
    "1.44505",
    "1.49923",
    "1.55133",
  ],
  12: [
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.064",
    "1.12553",
    "1.18469",
    "1.24158",
    "1.29628",
    "1.34888",
    "1.39945",
    "1.44808",
  ],
  13: [
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.05784",
    "1.11344",
    "1.16691",
    "1.21832",
    "1.26775",
    "1.31529",
    "1.36099",
  ],
  14: [
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "0",
    "1",
    "1.05257",
    "1.10312",
    "1.15172",
    "1.19845",
    "1.24338",
    "1.28659",
  ],
  15: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1.04803", "1.0942", "1.1386", "1.18129", "1.22233"],
  16: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1.04406", "1.08643", "1.12716", "1.16633"],
  17: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1.04058", "1.0796", "1.11711"],
  18: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1.0375", "1.07355"],
  19: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1.03475"],
  20: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1"],
};
